
@if (_active) {
  <kendo-window
    title="Copy Barcode Label"
    (close)="_active = false;"
    (stateChange)="_onStateChanges($event)"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow
    >
    <!-- Form -->
    <form novalidate [formGroup]="_form" class="form_style">
      <!-- Row Saves -->
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections margin-top-4">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Copy Barcode Label
                  <span
                    class="action-button action-button-viewMode"
                    >
                    <div class="action-button-icon">
                      <img
                        src="/assets/menu/enterprise/edit-action-icon-grid.svg"
                        />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  </h2>
                  <div class="upsert-header-buttons">
                    <ul class="menuButtonsList">
                      <li>
                        <button
                          (click)="_onSave()"
                          class="asap-btn"
                          kendoButton
                          >
                          save
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-12">
                  <div class="formsMenuSeparator"></div>
                </div>
              </div>
              <div class="row row_padding">
                <fieldset class="col-12 col-xl-9">
                  <div
                    class="form-group special_style_formgroup" style="display:grid"
                    >
                    <label for="name" class="control-label"
                      >Please enter a Label Name</label
                      >
                      <div class="input-group mb-3">
                        <input
                          type="text"
                          class="k-textbox writebox newFormControlWidth"
                          formControlName="name"
                          placeholder="Label Name"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-window>
      }










